/**
 * Résout un champ de branding d'une ville (logo, logo2, splash_background)
 * vers une URL utilisable directement dans un <img src> ou un CSS url().
 *
 *  - Valeur déjà une URL absolue (téléversée via l'espace Super Admin,
 *    phase 5 du plan multi-villes — stockée sur S3) → utilisée telle quelle.
 *  - Simple nom de fichier (comportement historique : asset statique intégré
 *    au build React, jamais téléversé) → préfixé par l'origine courante.
 *    Volontairement une URL ABSOLUE (pas un chemin relatif "images/…" ou
 *    "../images/…" comme le faisaient les différents écrans jusqu'ici) :
 *    un chemin relatif se résout différemment selon la profondeur de la
 *    route React Router courante — c'était déjà fragile, ça ne doit pas
 *    empirer avec cette évolution.
 */
export function brandingUrl(value: string | null | undefined): string {
    if (!value) {
        return '';
    }
    if (/^https?:\/\//i.test(value)) {
        return value;
    }
    return `${window.location.origin}/images/${value}`;
}
